import React, { useEffect, useState } from 'react';
import '../App.css';
import '../styles/joinUs.css';

import 'react-responsive-modal/styles.css';
import Button from '../components/Button';
import Input from '../components/Input';

interface Props {
    refProp: any;
}

const INDUSTRIES: string[] = [
    "Banking",
    "Insurance",
    "Pension",
    "Asset Management",
    "Payments/Fintech",
    "Law",
    "Accountancy",
    "Public Affairs",
    "Consulting",
    "Other"
];

function JoinUs({ refProp }: Props) {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [labourMember, setLabourMember] = useState('');
    const [industry, setIndustry] = useState('');

    const [jobTitle, setJobTitle] = useState('');
    const [companyName, setCompanyName] = useState('');

    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const submitDetails = async () => {
        if (!labourMember || !industry) {
            setSubmitted(false);
            setError('Please complete all required fields.');
            return;
        }

        try {
            const response = await fetch('/api/mailchimp', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    firstName,
                    lastName,
                    jobTitle,
                    companyName,
                    labourMember,
                    industry,
                }),
            });

            if (!response.ok) {
                setSubmitted(false);
                setError('Something went wrong, please refresh and try again.');
                return;
            }

            setSubmitted(true);
            setError('');
        } catch (error) {
            setError('Something went wrong, please refresh and try again.');
            setSubmitted(false);
        }
    };

    useEffect(() => {
        setError('');
        setSubmitted(false);
    }, [
        email,
        firstName,
        lastName,
        jobTitle,
        companyName,
        labourMember,
        industry,
    ]);

    return (
        <div className='join-section' ref={refProp}>
            <h1 className='section-title'>Join Us</h1>

            <p className='text-medium small'>
                Sign up below with your details, and we’ll be in touch.
            </p>

            <div className='form-container'>
                <div className='form'>
                    <div className='form-left'>
                        <h3 className='no-margin'>
                            Join Labour in the City
                        </h3>

                        <div className='form-left-lower'>
                            <img
                                src={require('../assets/wired-flat-981-consultation.gif')}
                                alt=""
                                className='join-icon'
                            />

                            <div className='form-left-lower-text'>
                                <p>
                                    Are you a Labour supporter working in
                                    Financial Services or any of the associated
                                    industries?
                                </p>
                                <p>Join today.</p>
                            </div>
                        </div>
                    </div>

                    <div className='form-right'>
                        <p className='form-entry-label-first'>
                            First Name
                        </p>

                        <Input
                            placeholder='John'
                            callback={(fName: string) =>
                                setFirstName(fName)
                            }
                        />

                        <p className='form-entry-label'>
                            Last Name
                        </p>

                        <Input
                            placeholder='Doe'
                            callback={(lName: string) =>
                                setLastName(lName)
                            }
                        />

                        <p className='form-entry-label'>
                            Email address
                        </p>

                        <Input
                            placeholder='someone@example.com'
                            callback={(email: string) =>
                                setEmail(email)
                            }
                        />

                        <p className='form-entry-label'>Job Title</p>
                        <Input
                            placeholder='e.g. Investment Analyst'
                            callback={(jobTitle: string) => setJobTitle(jobTitle)}
                        />

                        <p className='form-entry-label'>Company Name</p>
                        <Input
                            placeholder='e.g. Example Ltd'
                            callback={(companyName: string) => setCompanyName(companyName)}
                        />

                        <label
                            className='form-entry-label'
                            htmlFor='labour-member'
                        >
                            Are you a Labour member? *
                        </label>

                        <select
                            id='labour-member'
                            className='form-select'
                            value={labourMember}
                            onChange={(event) =>
                                setLabourMember(event.target.value)
                            }
                            required
                        >
                            <option value='' disabled>
                                Please select
                            </option>

                            <option value='yes'>Yes</option>
                            <option value='no'>No</option>
                        </select>

                        <label
                            className='form-entry-label'
                            htmlFor='industry'
                        >
                            Your industry *
                        </label>

                        <select
                            id='industry'
                            className='form-select'
                            value={industry}
                            onChange={(event) =>
                                setIndustry(event.target.value)
                            }
                            required
                        >
                            <option value='' disabled>
                                Please select
                            </option>

                            {INDUSTRIES.map((industryOption) => (
                                <option
                                    key={industryOption}
                                    value={industryOption}
                                >
                                    {industryOption}
                                </option>
                            ))}
                        </select>

                        {error && (
                            <p className='form-error'>
                                {error}
                            </p>
                        )}

                        <Button
                            type="tertiary"
                            text={!submitted ? 'Submit' : 'Submitted'}
                            callback={submitDetails}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinUs;